module.exports = __webpack_public_path__ + "static/Jira_mini-d1c8b742ceb37fdab816f7b70a1e9744.svg";